import { Route } from "react-router-dom";
import { lazy } from "react";

import Layout from "../layouts/layout";
import HomePage from "../pages/home";
import { ServicesRoutes } from './ServicesRoutes';

const AboutUs = lazy(() => import("../pages/aboutUs"));
const Offers = lazy(() => import("../pages/offers"));
const Profile = lazy(() => import("../pages/profile"));
const Library = lazy(() => import("../pages/masarLibrary"));
const AdvancedServices = lazy(() => import("../pages/advancedServices"));

const LogIn = lazy(() => import("../features/loginAndRegister/logIn"));
const Register = lazy(() => import("../pages/register"));
const ResetPassword = lazy(() => import("../features/loginAndRegister/resetPassword"));

const ContactUs = lazy(() => import("../pages/contactUs"));
const FAQPage = lazy(() => import("../pages/FAQ"));
const NotFound = lazy(() => import("../components/notFound"));

const LibraryBook = lazy(() => import("../features/library/libraryBook"));
const OffersDetails = lazy(() => import("../features/offers/OffersDetails"));
const AdvanceServiceDetails = lazy(() => import("../features/AdvancedServices/AdvanceServiceDetails"));

const Terms = lazy(() => import("../pages/terms").then(m => ({ default: m.Terms })));
const Policy = lazy(() => import("../pages/terms").then(m => ({ default: m.Policy })));

const ServicesProviders = lazy(() => import("../features/serviceProvider/servicesProviders"));

const PaymentForm = lazy(() => import("../features/payment/CheckoutPaymob"));
// const ServicesRoutes = lazy(() => import("./ServicesRoutes"));


// Before adding lazy imports, these were the original imports:

// import AboutUs from "../pages/aboutUs";
// import Offers from "../pages/offers";
// import Profile from "../pages/profile";
// import Library from "../pages/masarLibrary";
// import AdvancedServices from "../pages/advancedServices";
// import LogIn from "../features/loginAndRegister/logIn";
// import Register from "../pages/register";
// import ContactUs from "../pages/contactUs";
// import NotFound from "../components/notFound";
// import ResetPassword from "../features/loginAndRegister/resetPassword";
// import LibraryBook from "../features/library/libraryBook";
// import OffersDetails from "../features/offers/OffersDetails";
// import AdvanceServiceDetails from "../features/AdvancedServices/AdvanceServiceDetails";
// import { Terms, Policy } from "../pages/terms";
// import { ServicesProviders } from "../features/serviceProvider/servicesProviders";
// import { PaymentForm } from "../features/payment/CheckoutPaymob";
// import FAQPage from "../pages/FAQ";
// import ActiveUserPassword from "../features/user/login/registerActiveUser";

export function HomeRoutes() {

    return (
        <Route element={<Layout />}>

            <Route path="/" element={<HomePage />} />
            {ServicesRoutes()}
            <Route path="aboutUs" element={<AboutUs />} />
            <Route path="offers" element={<Offers />} />
            <Route path="offers/:OfferId/:OfferTitle" element={<OffersDetails />} />
            <Route path="advancedServices" element={<AdvancedServices />} />
            <Route path="advancedServices/:AdServiceId" element={<AdvanceServiceDetails />} />
            <Route path="profile" element={<Profile />} />
            <Route path="masarLibrary" element={<Library />} />
            <Route path="masarLibrary/:bookSetId/:bookSetTitle" element={<LibraryBook />} />
            {/* <Route path="masarLibrary/:bookSetTitle" element={<LibraryBook />} /> */}

            <Route path="FAQ" element={<FAQPage />} />
            <Route path="terms" element={<Terms />} />
            <Route path="policy" element={<Policy />} />
            <Route path="servicesProviders" element={<ServicesProviders />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="payment" element={<PaymentForm />} />
            <Route path="*" element={<NotFound />} />
            {/* <Route path="/auth/reset-password/:token" element={<ActiveUserPassword />} /> */}
            <Route path="logIn" element={<LogIn />} />
            <Route path="register" element={<Register />} />
            {/* <Route path="OTP" element={<OTPPage />} /> */}
            <Route path="resetPassword" element={<ResetPassword />} />
            {/* <Route path="adminLogin" element={<AdminLogIn />} /> */}
        </Route>
    );
}